import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyPinCode } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data6 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const PinCodeVerify = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pinCodeData, setPinCodeData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [pincode, setPinCode] = useState("");
  const [showPinCodeData, setShowPinCodeData] = useState(false);
  const { serviceName } = useService();


  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);


const validateForm = (pincode) => {
  const errors = {};
  if (!pincode.trim()) {
    errors.pincode = "Pincode is required.";
  } 
  return errors;
};


  
const handleSubmit = async () => {
  const validationErrors = validateForm(pincode);
  setErrors(validationErrors);
  if (Object.keys(validationErrors).length > 0) return;

  try {
    setIsLoading(true);

    const response = await verifyPinCode({
      api_id: profileData?.user_id,
      api_key: profileData?.api_key,
      token_id: profileData?.token_id,
      pincode: pincode,
    });

    const statusCode = response?.status?.code || response?.status;

    if (statusCode === 200) {
   
   const rcData = response?.data;  // <-- this is an ARRAY, perfect

   if (rcData) {
      setPinCodeData(rcData); // <-- directly store the array
      showSuccessToast(response.message, "Pincode Verified successfully.");
      setShowPinCodeData(true)
      setPinCode("");
      setErrors({});
   } else {
      showErrorToast("Unexpected API format.");
   }
}

    
    else if (statusCode === 422) {
      showErrorToast(response.data.message || "Invalid format");
    } 
    
    else if (statusCode === 500) {
      showErrorToast(response.data.message || "Server error");
    } 
    
    else {
      showErrorToast(response.status?.message || "Something went wrong");
    }

  } catch (error) {
    console.error("Pincode Error:", error);
    showErrorToast("Failed to verify pincode.");
  } finally {
    setIsLoading(false);
  }
};


  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
       
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

       
       
        <InputWithLabel
          type="text"
          label="Pincode"
          placeholder="Enter Pincode"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="pincode"
          id="pincode"
          required={true}
          value={pincode}
          onChange={(e) => setPinCode(e.target.value)}
          error={errors.pincode}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyRC"
            name="verifyRC"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

{pinCodeData && showPinCodeData &&
   (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 px-4">
      {/* Summary Card */}
      <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3">
        <h3 className="text-blue-800 font-semibold text-xl">Pincode Summary</h3>
        <div className="text-sm text-gray-700 mt-2">
          <p>
            <strong>Total Offices:</strong>{" "}
            {pinCodeData?.Message?.replace("Number of pincode(s) found:", "")}
          </p>

          <p><strong>Status:</strong> {pinCodeData?.Status || ""}</p>
          <p><strong>Pincode:</strong> {pinCodeData?.PostOffice[0]?.Pincode || ""}</p>
          <p><strong>District:</strong> {pinCodeData?.PostOffice[0]?.District || ""}</p>
          <p><strong>State:</strong> {pinCodeData?.PostOffice[0]?.State || ""}</p>
        </div>
      </div>

      {/* Post Office List */}
      <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3">
        <h3 className="text-blue-800 font-semibold text-xl">Post Office List</h3>

        <div className="mt-2 max-h-[220px] overflow-y-auto pr-2">
          {pinCodeData?.PostOffice?.map((po, index) => (
            <div key={index} className="border-b pb-2 mb-2">
              <p><strong>Name:</strong> {po.Name}</p>
              <p><strong>Branch Type:</strong> {po.BranchType}</p>
              <p><strong>Delivery Status:</strong> {po.DeliveryStatus}</p>
              <p><strong>District:</strong> {po.District}</p>
              <p><strong>State:</strong> {po.State}</p>
              <p><strong>Country:</strong> {po.Country}</p>
            </div>
          ))}
        </div>
      </div>

      {/* JSON Preview */}
      <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2">
        <h2 className="text-lg font-semibold text-blue-800 mb-1">Pincode JSON Data</h2>
        <pre className="bg-gray-100 p-2 rounded text-sm overflow-y-auto max-h-[200px]">
          {JSON.stringify(pinCodeData, null, 2)}
        </pre>
      </div>
    </div>
)}


    </>
  );
};

export default PinCodeVerify;
